import { FC } from "react";
import { DefaultCompProps } from "./type";

const ShiptoHeader: FC<DefaultCompProps & Record<string, any>> = (props) => {
    const { style, children, className, defaultText, onClick, ...otherProps } = props;
    return <>
        <div style={style} className={className} onClick={onClick}>
            {children}
        </div>
    </>;
};
export default ShiptoHeader;